<div *ngIf="isAuthenticated">
    <a class="p-2 text-light" (click)="signout()" href="javascript:void(0)">Signout {{name}}</a>               

</div>
<div class="container">
    <div class="jumbotron mt-3">
      <h1>Test Index Page</h1>
      <a class="btn btn-lg btn-primary" routerLink="/account/register" role="button">Signup Page &raquo;</a>
      <a class="btn btn-lg btn-primary ml-4" routerLink="/account/login" role="button">Login Page &raquo;</a>
      <a class="btn btn-lg btn-primary ml-4" routerLink="/securePage/data" role="button">Secure Page &raquo;</a>
    </div>
</div>
